try {
            require('./index.css');
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e; // Re-throw unexpected errors
            }
            console.warn('index.css not found, proceeding without it.');
          }
          

import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '@design-system/icon';
import classNames from 'classnames';
import { forwardRef, useState, useEffect } from 'react';

try {
  require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$1(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const Link = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
    variant = 'primary',
    size = 'small',
    children,
    className,
    iconPrefix,
    iconSuffix,
    href
  } = _a,
      htmlProperties = __rest$1(_a, ["variant", "size", "children", "className", "iconPrefix", "iconSuffix", "href"]);

  const IconPrefixComponent = (iconPrefix === null || iconPrefix === void 0 ? void 0 : iconPrefix.component) || Icon;
  const IconSuffixComponent = (iconSuffix === null || iconSuffix === void 0 ? void 0 : iconSuffix.component) || Icon;
  return jsxs("a", Object.assign({
    ref: ref,
    href: href,
    className: classNames('cds-link', className, `cds-link--${variant}`, `cds-link--${variant}-${size}`)
  }, htmlProperties, {
    children: [(iconPrefix === null || iconPrefix === void 0 ? void 0 : iconPrefix.props) && jsx(IconPrefixComponent, Object.assign({
      className: classNames('icon__prefix', `icon--${variant}-icon`)
    }, iconPrefix.props)), jsx("span", Object.assign({
      className: classNames('cds-link__inner', {
        'cds-sr-only': variant.includes('-icon')
      })
    }, {
      children: children
    })), (iconSuffix === null || iconSuffix === void 0 ? void 0 : iconSuffix.props) && jsx(IconSuffixComponent, Object.assign({
      className: classNames('icon__suffix', `icon--${variant}-icon`)
    }, iconSuffix.props))]
  }));
});

try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const getClassName = _ref => {
  let {
    align,
    variant,
    wrapping,
    className,
    size,
    weight
  } = _ref;
  const isBodyOrHeadlineOrDetail = variant === 'body' || variant === 'headline' || variant === 'detail';
  return classNames('cds-typography', className, {
    [`cds-typography--align-${align}`]: align,
    [`cds-typography--variant-${variant}`]: variant,
    [`cds-typography--variant-${variant}-${size}`]: isBodyOrHeadlineOrDetail && size,
    [`cds-typography--wrapping-${wrapping}`]: wrapping,
    [`cds-typography--weight-${weight}`]: isBodyOrHeadlineOrDetail && weight
  });
};

const unwrapFirstTag = (typographyTag, typographyVariant, typographyContent) => {
  const openTagRegExp = /^<\/?[^>]+(>|$)/g;
  const closeTagRegExp = /<\/[^>]+(>$)/g;
  return typographyVariant !== 'rte' && typographyTag !== 'div' ? typographyContent.toString().replace(openTagRegExp, '').replace(closeTagRegExp, '') : typographyContent;
};

const Typography = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
    content,
    tag = 'div',
    variant,
    align,
    className,
    size = 'm',
    weight = 'regular',
    wrapping = 'break-word',
    link
  } = _a,
      htmlProperties = __rest(_a, ["content", "tag", "variant", "align", "className", "size", "weight", "wrapping", "link"]);

  const LinkElement = (link === null || link === void 0 ? void 0 : link.component) || Link;
  const typographyClassName = getClassName({
    align,
    variant,
    wrapping,
    className,
    size,
    weight
  });
  const Tag = tag && variant !== 'rte' ? tag : 'div';
  const html = unwrapFirstTag(tag, variant, content);
  return link ? jsx(Tag, Object.assign({
    className: typographyClassName,
    ref: ref
  }, htmlProperties, {
    children: jsx(LinkElement, Object.assign({}, link.props, {
      iconPrefix: undefined,
      iconSuffix: undefined
    }, {
      children: jsx("span", {
        dangerouslySetInnerHTML: {
          __html: html
        }
      })
    }))
  })) : jsx(Tag, Object.assign({
    className: typographyClassName,
    ref: ref,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }, htmlProperties));
});

const useQuantity = (initialValue, messages, { min, max, isMinSet, isMaxSet, onChange }) => {
    const [quantityValue, setQuantityValue] = useState(initialValue);
    const [validateMessage, setValidateMessage] = useState('');
    const [isValueValid, setIsValueValid] = useState(true);
    const handleReset = () => setQuantityValue(min);
    const verifyValue = () => {
        setIsValueValid(false);
        if (!Number.isInteger(quantityValue)) {
            setQuantityValue(min && min > 0 ? min : 0);
        }
        if (isMaxSet && quantityValue > max) {
            setQuantityValue(max);
            setValidateMessage(messages.maxLimitErrorMessage);
        }
        else if (isMinSet && quantityValue < min) {
            setQuantityValue(min);
            setValidateMessage(messages.minLimitErrorMessage);
        }
        else {
            setIsValueValid(true);
        }
    };
    const increment = () => {
        if (!isMaxSet || quantityValue < max) {
            setQuantityValue(quantityValue + 1);
        }
        else {
            setValidateMessage(messages.maxLimitErrorMessage);
        }
    };
    const decrement = () => {
        if (!isMinSet || quantityValue > min) {
            setQuantityValue(quantityValue - 1);
        }
        else {
            setValidateMessage(messages.minLimitErrorMessage);
        }
    };
    const handleChange = (event) => {
        const val = event.target.value;
        if (val !== '' && Number(val) < 1) {
            setQuantityValue(min || 0);
            return;
        }
        setQuantityValue(Number(val));
    };
    useEffect(() => {
        verifyValue();
        if (isValueValid) {
            onChange(quantityValue);
        }
    }, [isValueValid, quantityValue]);
    useEffect(() => {
        const timeId = setTimeout(() => {
            setValidateMessage('');
        }, 3000);
        return () => {
            clearTimeout(timeId);
        };
    }, [validateMessage]);
    const handleBlur = () => {
        verifyValue();
    };
    const handleKeyDown = (e) => {
        if (e.key !== 'Backspace' &&
            e.key !== 'ArrowLeft' &&
            e.key !== 'ArrowRight' &&
            e.key !== 'ArrowUp' &&
            e.key !== 'ArrowDown' &&
            !/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
        if (e.key === 'Enter') {
            verifyValue();
        }
    };
    return {
        quantityValue,
        validateMessage,
        increment,
        decrement,
        handleReset,
        handleChange,
        handleKeyDown,
        handleBlur,
    };
};

const defaultMessages = {
    maxLimitErrorMessage: 'Max limit reached',
    minLimitErrorMessage: 'Minimum limit reached',
};
const QuantityButton = forwardRef(({ id, className, label, value, onChange, onKeyDown, reset, hasError, onBlur, variant, max, min, errorMessage, increaseAriaLabel, decreaseAriaLabel, inputAriaLabel, }, ref) => {
    const isMinSet = min !== undefined && min !== null;
    const isMaxSet = max !== undefined && max !== null;
    const messages = Object.assign(Object.assign({}, defaultMessages), errorMessage);
    const { quantityValue, validateMessage, increment, decrement, handleReset, handleChange, handleKeyDown, handleBlur, } = useQuantity(value, messages, {
        min,
        max,
        isMinSet,
        isMaxSet,
        onChange,
    });
    useEffect(() => {
        if (reset)
            handleReset();
    }, [reset]);
    const handleOnBlur = () => {
        handleBlur();
        if (onBlur) {
            onBlur();
        }
    };
    const handleOnKeyDown = (e) => {
        if (e.key === 'Tab')
            return;
        handleKeyDown(e);
        if (onKeyDown) {
            onKeyDown(e);
        }
    };
    return (jsxs("div", Object.assign({ className: classNames('cds-quantity-button', `cds-quantity-button--${variant}`, className, {
            'cds-quantity-button--error': Boolean(hasError),
        }) }, { children: [label ? (jsx("label", Object.assign({ className: "cds-quantity-button__label-wrapper", htmlFor: id }, { children: jsx(Typography, { className: "cds-quantity-button__label", variant: "body", size: "xs", content: label, tag: "p", weight: "regular" }) }))) : null, jsxs("div", Object.assign({ className: "cds-quantity-button__wrapper" }, { children: [jsx("button", Object.assign({ className: classNames('cds-quantity-button__dec-button', {
                            'cds-quantity-button__dec-button--disabled': isMinSet && quantityValue === min,
                        }), type: "button", "data-testid": "btn-dec", onClick: decrement, "aria-label": decreaseAriaLabel }, { children: jsx(Icon, { icon: "hide", size: 16 }) })), jsx("input", { id: id, className: "cds-quantity-button__input", type: "number", value: quantityValue, onChange: handleChange, onBlur: handleOnBlur, onKeyDown: handleOnKeyDown, ref: ref, max: max, min: min, size: quantityValue === null || quantityValue === void 0 ? void 0 : quantityValue.toString.length, "aria-label": inputAriaLabel }), jsx("button", Object.assign({ className: classNames('cds-quantity-button__inc-button', {
                            'cds-quantity-button__inc-button--disabled': isMaxSet && quantityValue === max,
                        }), type: "button", "data-testid": "btn-inc", onClick: increment, "aria-label": increaseAriaLabel }, { children: jsx(Icon, { icon: "add", size: 16 }) }))] })), validateMessage.length > 0 ? (jsx("div", Object.assign({ className: "cds-quantity-button__error" }, { children: validateMessage }))) : null] })));
});

export { QuantityButton };
